import { render, staticRenderFns } from "./CgsbwhView.vue?vue&type=template&id=8d416e7e&scoped=true"
import script from "./CgsbwhView.vue?vue&type=script&lang=js"
export * from "./CgsbwhView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d416e7e",
  null
  
)

export default component.exports